import { Box, Typography } from '@mui/material';
import {
  DialogContainer,
  DialogBody,
} from '../../../../common/components';
import { useExcelExport } from '../../../habitat-99/hooks/useExcelExport';
import { usePDFExport } from '../../../habitat-99/hooks/usePDFExport';
import StatisticsDialogTitle from '../../../habitat-99/components/common/StatisticsDialogTitle';
import CollectionsSummaryTable from '../CollectionsSummaryTable';

const CollectionsSummaryModal = ({
  open,
  handleClose,
  header,
  results = [],
  totals,
  groupColumns,
}) => {
  const { exportToExcel } = useExcelExport();
  const { exportToPDF } = usePDFExport();
  const hasData = results.length > 0;

  const handleExportExcel = () => {
    if (!hasData) return;
    const excelData = results.map((row) => {
      const groupValues = groupColumns.reduce((acc, column) => {
        acc[column] = row.groups?.[column] ?? 0;
        return acc;
      }, {});

      return {
        Entidad: row.legal_entity_name,
        ...groupValues,
        Total: row.total,
      };
    });

    excelData.push({ Entidad: 'TOTALES', ...totals.groups, Total: totals.total });
    exportToExcel(excelData, 'ResumenCobranzas');
  };

  const handleExportPDF = () => {
    if (!hasData) return;
    const headers = ['Entidad', ...groupColumns, 'Total'];
    const data = results.map((row) => [
      row.legal_entity_name,
      ...groupColumns.map((column) => row.groups?.[column] ?? 0),
      row.total,
    ]);

    data.push([
      'TOTALES',
      ...groupColumns.map((column) => totals.groups?.[column] ?? 0),
      totals.total,
    ]);

    exportToPDF({
      title: 'Resumen de Cobranzas',
      headers,
      data,
      filename: 'ResumenCobranzas',
      orientation: 'landscape',
    });
  };

  return (
    <DialogContainer open={open} onClose={handleClose} size="large">
      <StatisticsDialogTitle
        title="Resumen de Cobranzas"
        onExportExcel={handleExportExcel}
        onExportPDF={handleExportPDF}
        onClose={handleClose}
        showExcelButton={hasData}
        showPdfButton={hasData}
      />
      <DialogBody>
        {!hasData && (
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography variant="body2" color="text.secondary">
              No se encontraron resultados para los filtros seleccionados.
            </Typography>
          </Box>
        )}
        <CollectionsSummaryTable
          header={header}
          results={results}
          totals={totals}
          groupColumns={groupColumns}
        />
      </DialogBody>
    </DialogContainer>
  );
};

export default CollectionsSummaryModal;
